import { toast } from 'sonner';
import { API } from '../../config/api';
import { DataService } from '../../config/dataService/dataService';
import { paramsToQueryString } from '../../utility/helpers/commonFunction';

export const getSupplierListApi = (params) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);
            const response = await DataService.get(API.supplier.getlist + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.supplier.getlist,
                    supplierData: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const getSupplieDetailApi = (id) => {
    return async (dispatch) => {
        try {
            const response = await DataService.get(API.supplier.getDetail + id);
            if (!response.data.error) {
                dispatch({
                    type: API.supplier.getDetail,
                    supplierDetail: response.data.data,
                });
                return response.data.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const getInvoiceByDetails = (params) => {
    return async (dispatch) => {
        try {
            console.log('🚀 ~ getInvoiceByDetails ~ params:', params);
            const queryString = paramsToQueryString(params);
            const response = await DataService.get(API.supplier.invoiceListByInventory + queryString);
            if (!response.data.error) {
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const createSupplierApi = (body) => {
    return async (dispatch) => {
        try {
            const response = await DataService.post(API.supplier.create, body);
            if (response.data.status) {
                return response.data.data;
            } else {
                toast.error(response.data?.message);
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const updateSupplierApi = (id, body) => {
    return async (dispatch) => {
        try {
            const response = await DataService.put(API.supplier.update + id, body);
            if (!response.data.error) {
                return response.data.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const deleteSupplierApi = (id) => {
    return async (dispatch) => {
        try {
            const response = await DataService.delete(API.supplier.delete + id);
            if (!response.data.error) {
                toast.success(response?.data?.message);
                return response.data.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const getSupplierNotesListApi = (params) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);
            const response = await DataService.get(API.supplier.notes.get + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.supplier.notes.get,
                    noteList: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const addSupplierNote = (payload) => async (dispatch) => {
    try {
        const response = await DataService.post(API.supplier.notes.create, payload);
        if (response.data.status) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

export const updateSupplierNoteApi = (id, payload) => async (dispatch) => {
    try {
        const response = await DataService.put(API.supplier.notes.update + id, payload);
        if (response.data.status) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};
export const deleteSupplierNoteApi = (id) => async (dispatch) => {
    try {
        const response = await DataService.delete(API.supplier.notes.delete + id);
        if (response.data.status) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

export const getSupplierCustomerInvoiceApi = (params) => {
    return async (dispatch) => {
        try {
            const queryString = paramsToQueryString(params);
            const response = await DataService.get(API.supplier.invoiceList + queryString);
            console.log('🚀 ~ return ~ response:', response);
            if (!response.data.error) {
                dispatch({
                    type: API.supplier.invoiceList,
                    supplierInvoiceData: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const getSupplierInvoiceListApi = (params, supplierArray) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);
            if (supplierArray && supplierArray?.length > 0) {
                supplierArray.forEach((item) => (queryString += `&supplier=${item}`));
            }
            const response = await DataService.get(API.supplier.supplierInvoice.getList + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.supplier.supplierInvoice.getList,
                    supplierInvoiceList: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const checkSupplierExistApi = (body) => {
    return async (dispatch) => {
        try {
            const response = await DataService.post('supplier-Invoice/invoice-number-check-exist', body);
            if (!response.data.error) {
                return response.data?.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
export const getSupplierInvoiceSingletApi = (id) => {
    return async (dispatch) => {
        try {
            const response = await DataService.get(API.supplier.supplierInvoice.getSingle + id);
            if (!response.data.error) {
                dispatch({
                    type: API.supplier.supplierInvoice.getList,
                    supplierInvoiceList: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const getSupplierInvoiceDetail = (id) => {
    return async (dispatch) => {
        try {
            const response = await DataService.get(API.supplier.supplierInvoice.getSingle + id);
            if (!response.data.error) {
                dispatch({
                    type: API.supplier.supplierInvoice.getSingle,
                    supplierInvoiceDetail: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};
export const clearSupplierInvoiceDetail = () => ({
    type: 'CLEAR_SUPPLIER_INVOICE_DETAIL',
});

export const createSupplierInvoiceApi = (body) => {
    return async (dispatch) => {
        try {
            const response = await DataService.post(API.supplier.supplierInvoice.create, body);

            if (response.data.status) {
                toast.success(response.data?.message);
                return response.data.data;
            } else {
                return false;
            }
        } catch (error) {
            console.log('🚀 ~ return ~ error:', error);
            return false;
        }
    };
};
export const updateSupplierInvoiceApi = (id, body) => {
    return async (dispatch) => {
        try {
            const response = await DataService.put(API.supplier.supplierInvoice.common + id, body);
            if (response.data.status) {
                return response.data.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const deleteSupplierInvoiceApi = (id) => {
    return async (dispatch) => {
        try {
            const response = await DataService.delete(API.supplier.supplierInvoice.delete + id);
            console.log('🚀 ~ return ~ response:', response);
            if (response.data.status) {
                return true;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const deletePartFromSupplierInvoiceApi = async (params) => {
    try {
        let queryString = paramsToQueryString(params);
        const response = await DataService.delete(API.supplier.supplierInvoice.deletePart + queryString);

        if (response.data.status) {
            return true;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

export const updateRecordPaymentApi = (body) => {
    return async (dispatch) => {
        try {
            const response = await DataService.post(API.supplier.supplierInvoice.recordPaymentCreate, body);
            if (response.data.status) {
                return response.data.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const amountSupplierInvoiceApi = async (id) => {
    try {
        const response = await DataService.get(API.supplier.supplierInvoice.paymentId + id);
        if (response.data.status) {
            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};
